import { render, staticRenderFns } from "./3_2_magazineDetail.vue?vue&type=template&id=1bf2fbda&scoped=true&"
import script from "./3_2_magazineDetail.vue?vue&type=script&lang=js&"
export * from "./3_2_magazineDetail.vue?vue&type=script&lang=js&"
import style0 from "./3_2_magazineDetail.vue?vue&type=style&index=0&id=1bf2fbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2fbda",
  null
  
)

export default component.exports